import { render, staticRenderFns } from "./form-change-name.vue?vue&type=template&id=722f0dde&scoped=true&lang=pug"
import script from "./form-change-name.vue?vue&type=script&lang=js"
export * from "./form-change-name.vue?vue&type=script&lang=js"
import style0 from "./form-change-name.vue?vue&type=style&index=0&id=722f0dde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722f0dde",
  null
  
)

export default component.exports